<h2 mat-dialog-title>
    Verification Results
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
</h2>
<div *ngIf="showProgressBar" class="progress-bar-container">
    <mat-progress-bar mode="indeterminate">
    </mat-progress-bar>
</div>
<mat-dialog-content>

    <mat-accordion>
        <mat-expansion-panel *ngFor="let contact of data.contactVerificationResult; let j = index" [expanded]="data.contactVerificationResult.length === 1" (opened)="contactPanelExpand(true)" (closed)="contactPanelClose(false)">
            <mat-expansion-panel-header class="contact-accodion">
                <mat-panel-title>
                    <strong>{{ contact.contact.contactName }}</strong>
                    <span>
                        ({{
                            contact.status.toLowerCase() == 'accept' ? 'Accepted' :
                            contact.status.toLowerCase() == 'referred' ? 'Referred' :
                            contact.status.toLowerCase() == 'decline' ? 'Declined' : contact.status
                        }})
                    </span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-accordion>
                <mat-expansion-panel (opened)="panelExpand(true)" (closed)="panelClose(false)" expanded="true">
                    <mat-expansion-panel-header class="audit-trail-header">
                        <mat-panel-title> Audit Trail Details</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="application-content">
                        <b>Audit</b>
                        <mat-divider></mat-divider>
                        <div class="refferal-content">
                            <div><p>Audit Ref </p>{{contact.verificationResponse.auditReference}}</div>
                            <div><p>Journey</p>{{contact.verificationResponse.journeyId.name}}</div>
                            <div><p>Journey Risk Level</p>{{contact.verificationResponse.riskLevel}}</div>
                            <div>
                                <p>Name</p>{{contact.verificationResponse.nameReference}}
                            </div>
                        </div>
                    </div>
                    <div class="application-content">
                        <b>Referral</b>
                        <mat-divider></mat-divider>
                        <div class="refferal-status">
                            <div [ngClass]="{'status-referred': contact.status.toLowerCase()=='referred', 'status-pass': contact.status.toLowerCase()=='accept', 'status-fail': contact.status.toLowerCase()=='decline' }">
                                <!--<p>Referral Status</p>{{contact.status}}-->
                                <p>Referral Status</p>
                                {{
                                   contact.status.toLowerCase() == 'accept' ? 'Accepted' :
                                   contact.status.toLowerCase() == 'referred' ? 'Referred' :
                                   contact.status.toLowerCase() == 'decline' ? 'Declined' : contact.status
                                }}
                            </div>
                            <div *ngIf="contact.status.toLowerCase()=='referred'"><p>Please review this ID Check manually by clicking here:</p><a href="{{contact.link}}" target="_blank">Link</a></div>
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelExpand(true)" (closed)="panelClose(false)">
                    <mat-expansion-panel-header class="audit-trail-header">
                        <mat-panel-title> Application Details</mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div>
                        <div class="application-content">
                            <div class="application-section" *ngIf="!contact.contact.isCompany && contact.verificationResponse">
                                <b>Application</b>
                                <mat-divider></mat-divider>
                                <div class="refferal-content">
                                    <div>
                                        <p>Application Date:</p>
                                        {{ contact.verificationResponse.startDateTime | date: 'dd-MM-yyyy  HH:mm' }}
                                    </div>
                                    <div>
                                        <p>Purpose of Borrowing:</p> ONBOARDING
                                    </div>
                                    <div><p>Client Application Reference:</p> {{contact.verificationResponse.clientApplicationReference}}</div>
                                    <div><p>Country:</p>{{contact.contact.country}}</div>
                                    <div><p>Account Reference:</p>{{contact.verificationResponse.accountReference}}</div>
                                </div>
                            </div>

                            <div class="application-section" *ngIf="!contact.contact.isCompany && contact.verificationResponse">
                                <b>Applicant</b>
                                <mat-divider></mat-divider>
                                <div class="refferal-content">
                                    <div><p>Role:</p> {{contact.contact.role}}</div>
                                    <div><p>First Name:</p>{{contact.contact.firstName}}</div>
                                    <div><p>Last Name:</p>{{contact.contact.lastName}}</div>
                                    <div><p>Date Of Birth:</p>{{contact.contact.dateOfBirth | date: 'dd-MM-yyyy'}}</div>
                                </div>
                            </div>

                            <div class="application-section" *ngIf="contact.contact.isCompany && contact.verificationResponse">
                                <b>Application</b>
                                <mat-divider></mat-divider>
                                <div class="refferal-content">
                                    <div><p>Client Application Reference:</p> {{contact.verificationResponse.clientApplicationReference}}</div>
                                    <div>
                                        <p>Country:</p> {{contact.contact.country}}
                                    </div>
                                    <div><p>Client User Id:</p> {{contact.verificationResponse.clientApplicationReference}}</div>
                                </div>
                            </div>

                            <div class="application-section" *ngIf="contact.contact.isCompany && contact.verificationResponse">
                                <b>Company</b>
                                <mat-divider></mat-divider>
                                <div class="refferal-content">
                                    <div><p>Business Name:</p> {{contact.contact.contactName}}</div>
                                    <div><p>Company Type:</p>LTD</div>

                                    <!--<div><p>Country Of Incorporation:</p>{{companyDetails.countryOfIncorporation}}</div>-->
                                    <!--<div><p>Country Of Registration:</p>{{companyDetails.countryOfRegistration}}</div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel (opened)="panelExpand(true)" (closed)="panelClose(false)">
                    <mat-expansion-panel-header class="audit-trail-header">
                        <mat-panel-title> Rules</mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="status-business-outcome" *ngIf="contact.hasBusinessRiskFinding">
                        <mat-icon>warning</mat-icon>
                        <span>Business outcome: {{ contact.riskLevel || 'A risk finding was identified for this application.' }}</span>
                    </div>

                    <div class="risk-details">
                        <div><b class="left">Risk Level:</b>{{contact.verificationResponse.riskLevel}}</div>
                        <div *ngIf="hasRuleOutcomes(contact)"><b class="right">Score:</b>{{contact.verificationResponse.rulesetOutcomes[0].score}}</div>
                    </div>

                    <table mat-table *ngIf="hasRuleOutcomes(contact)" [dataSource]="contact.verificationResponse.rulesetOutcomes[0].ruleOutcomes" class="mat-elevation-z8 demo-table" sstyle="width:96%">
                        <ng-container matColumnDef="Name">
                            <th mat-header-cell *matHeaderCellDef> Name</th>
                            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Outcome">
                            <th mat-header-cell *matHeaderCellDef> Outcome </th>
                            <td mat-cell *matCellDef="let element"> {{element.outcome}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="Score">
                            <th mat-header-cell *matHeaderCellDef> score </th>
                            <td mat-cell *matCellDef="let element"> {{element.score}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <div class="no-rule-outcomes" *ngIf="!hasRuleOutcomes(contact)">
                        No rule-level outcome details are available for this application.
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel (opened)="panelExpand(true)" (closed)="panelClose(false)" *ngIf="contact.contact.isCompany" >
                    <mat-expansion-panel-header class="audit-trail-header">
                        <mat-panel-title> UBO Details</mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <span *ngIf="contact.ubos &&contact.ubos.length > 0" class="edit-note">Click on the Date of Birth, Email, or Address fields to edit.</span>
                    <table mat-table *ngIf="contact.ubos &&contact.ubos.length > 0" [dataSource]="contact.ubos" class="mat-elevation-z8 ubos">
                        <ng-container matColumnDef="Contact name">
                            <th mat-header-cell *matHeaderCellDef class="contact-name"> Contact name</th>
                            <td mat-cell *matCellDef="let element" (click)="closeFields()"> {{element.contactName || ''}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Type">
                            <th mat-header-cell *matHeaderCellDef class="type"> Type </th>
                            <td mat-cell *matCellDef="let element" (click)="closeFields()">
                                {{ element.type !== null ? element.isCompany ? "Company":"Individual" + " " +"("+ element.type +")" : ''}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Requirements">
                            <th mat-header-cell *matHeaderCellDef class="requirements"> Field Requirements </th>
                            <td mat-cell *matCellDef="let element" (click)="closeFields()">
                                <xp-country-field-requirements [contact]="element" [config]="configFor(element)" [citizenshipCodes]="citizenshipCodes"></xp-country-field-requirements>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Dob">
                            <th mat-header-cell *matHeaderCellDef class="dob"> Date of Birth </th>
                            <td mat-cell *matCellDef="let element; let i = index" [ngClass]="{'editable-cell' : !element.isCompany}" (click)="updateDob(i)" class="clickable-div">
                                <div *ngIf="isUpdateDob !== i">
                                    {{element.dateOfBirth | date: 'dd-MM-yyyy'}}
                                </div>
                                <div *ngIf="isUpdateDob === i && !element.isCompany">
                                    <div class="birth-date">
                                        <div class="container">
                                            <div class="input-container">
                                                <mat-form-field class="custom-input-field">
                                                    <input matInput [matDatepicker]="picker" [value]="element.dateOfBirth " #dobInput />
                                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                                <mat-checkbox class="save-address-checkbox" disableRipple [checked]="isDobChecked" (change)="saveDob($event, i,j, dobInput.value)">Save Date</mat-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Phone">
                            <th mat-header-cell *matHeaderCellDef class="phone"> Phone </th>
                            <td mat-cell *matCellDef="let element" (click)="closeFields()"> {{element.phone|| ''}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Email">
                            <th mat-header-cell *matHeaderCellDef class="email"> Email </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="editable-cell clickable-div" (click)="updateEmail(i)">
                                <div *ngIf="isUpdateEmail !== i">
                                    {{element.email || ''}}
                                </div>
                                <div *ngIf="isUpdateEmail === i">
                                    <div class="email">
                                        <div class="container">
                                            <div class="input-container">
                                                <mat-form-field class="custom-input-field">
                                                    <input type="email" matInput [value]="element.email" #emailInput />
                                                </mat-form-field>
                                                <mat-error *ngIf="emailError[i]" class="error-message">{{ emailError[i] }}</mat-error>

                                                <mat-checkbox class="save-address-checkbox" disableRipple [checked]="isEmailChecked" [disabled]="validateEmailInput(emailInput.value, i)" (change)="saveEmail($event, i,j, emailInput.value)">Save Email</mat-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Address">
                            <th mat-header-cell *matHeaderCellDef class="address"> Address </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="editable-cell clickable-div" (click)="updateAddress(i)">

                                <div *ngIf="isUpdateAddress != i">
                                    {{ createAddress(element) || ''}}
                                </div>

                                <div *ngIf="isUpdateAddress === i">
                                    <div class="container">
                                        <div class="input-container">
                                            <div class="combo-input-part">
                                                <input matInput placeholder="House Number" [value]="element.houseNumber" #houseNumber class="input-part" />
                                                <div class="seperator"></div>
                                                <input matInput placeholder="Street" [value]="element.street" #street class="input-part" />
                                            </div>

                                            <div class="combo-input">
                                                <input matInput placeholder="City" [value]="element.city" #city class="input-part" />
                                                <div class="seperator"></div>
                                                <input matInput placeholder="State/Province" [value]="element.state" #province class="input-part" />
                                            </div>

                                            <div class="combo-input">
                                                <input matInput placeholder="Country*" [value]="element.country" #country class="input-part" />
                                                <div class="seperator"></div>
                                                <input matInput placeholder="Zip Post Code*" [value]="element.postcode" #zipPostCode class="input-part" />
                                            </div>
                                            <mat-error *ngIf="addressError[i]" class="error-message address-error">{{ addressError[i] }}</mat-error>
                                            <mat-checkbox class="save-address-checkbox" disableRipple [checked]="isAddressChecked" (change)="saveAddress($event,i,j,houseNumber.value, street.value, city.value, province.value, country.value, zipPostCode.value)">Save Address</mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Company Reg">
                            <th mat-header-cell *matHeaderCellDef class="company-reg"> Company Reg </th>
                            <td mat-cell *matCellDef="let element" (click)="closeFields()"> {{element.businessRegNumber|| ''}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Ubo Percentage">
                            <th mat-header-cell *matHeaderCellDef class="Threshold"> Threshold </th>
                            <td mat-cell *matCellDef="let element" (click)="closeFields()"> {{element.uboPercentage}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Role">
                            <th mat-header-cell *matHeaderCellDef class="role"> Role </th>
                            <td mat-cell *matCellDef="let element; let i = index" (click)="closeFields()">
                                <div>
                                    <mat-form-field class="role-drop-down">
                                        <mat-label>Select Role</mat-label>
                                        <mat-select disableRipple [(ngModel)]="element.role" (selectionChange)="onRoleChange($event, i,j)" [disabled]="element.isCompany">
                                            <mat-option value="Director">Director</mat-option>
                                            <mat-option value="Shareholder">Shareholder</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-error *ngIf="roleError" class="error-message role-error">{{ roleError[i] }}</mat-error>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Documents">
                            <th mat-header-cell *matHeaderCellDef class="doc" > Documents </th>
                            <td mat-cell *matCellDef="let element; let i = index" >

                                <!-- Always show the button -->
                                <button class="btn-select" (click)="onButtonClick(i, j, 1)">Add Document</button>

                                <div *ngIf="element.selectedDocuments?.length">
                                    <div class="selected-docs">
                                        <ul>
                                            <li *ngFor="let doc of getdocumentsbytype(element.selectedDocuments,'POI'); let k = index"
                                                [class.border-bottom]="element.selectedDocuments.length > 1 && k < element.selectedDocuments.length - 1"
                                                class="list-item-doctype">
                                                <div>{{ doc.name }}{{ doc.extension }}</div>
                                                <button class="remove-doc-btn" title="Remove Document" (click)="removeDocument(i, j, doc)">
                                                    <mat-icon>cancel</mat-icon>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Proof of Address">
                            <th mat-header-cell *matHeaderCellDef class="addressid" [hidden]="isPOASelected()"> Proof of Address </th>
                            <td mat-cell *matCellDef="let element; let i = index" [hidden]="isPOASelected()">

                                <!-- Always show the Add Document button -->
                                <button class="btn-select" (click)="onButtonClick(i, j, 2)">Add Document</button>

                                <!-- Only display the document list if documents exist -->
                                <div *ngIf="element.selectedDocuments?.length">
                                    <div class="selected-docs">
                                        <ul>
                                            <li *ngFor="let doc of getdocumentsbytype(element.selectedDocuments,'POA'); let k = index"
                                                [class.border-bottom]="element.selectedDocuments.length > 1 && k < element.selectedDocuments.length - 1"
                                                class="list-item-doctype">
                                                <div>{{ doc.name }}{{ doc.extension }}</div>
                                                <button class="remove-doc-btn" title="Remove Document" (click)="removeDocument(i, j, doc)">
                                                    <mat-icon>cancel</mat-icon>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Action">
                            <th mat-header-cell *matHeaderCellDef class="action"> Action </th>
                            <td mat-cell *matCellDef="let element; let i = index">
                                <button mat-raised-button class="btn-verify-company-contact" [disabled]="isVerifyDisabled" (click)="verify(element, i)">Verify</button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="uboColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: uboColumns;"></tr>
                    </table>
                </mat-expansion-panel>
            </mat-accordion>

            <mat-dialog-actions>
                <button mat-raised-button
                        *ngIf="!downloadPdfBtn"
                        class="btn-verify"
                        (click)="uploadPDF(contact.auditId)"
                        [disabled]="contact.status.toLowerCase() === 'referred' || isUploadingPdf ">

                    {{ isUploadingPdf ? 'Saving…' : 'Save to ActionStep' }}
                </button>

                <button  mat-raised-button
                        *ngIf="downloadPdfBtn"
                        class="btn-verify" (click)="downloadPDF(contact.auditId)">Download PDF</button>
            </mat-dialog-actions>
        </mat-expansion-panel>
    </mat-accordion>
</mat-dialog-content>
